import React, { render } from 'preact/compat';

export const renderComponent = (Component, selector) => {
  const el = document.querySelector(selector);
  if (el) {
    return () => render(<Component />, el);
  }
  return () => {};
};

export default {
  renderComponent,
};



// WEBPACK FOOTER //
// ./src/scripts/modules/Utils/index.js